// import packages
import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";

// Import assets
import "./about.scss"
import {PlayBtnIcon} from "../../../assets/images";

// Import utils
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import VisibilitySensor from "react-visibility-sensor";
import {CountUp} from "use-count-up";
import LinkBtn from "../../../components/buttons/LinkBtn";
import VideoModal from "../../../components/ui-elements/video-modal/VideoModal";


export function About(props) {
    const {about, staticTexts,settings} = props
    const [videoData, setVideoData] = useState(null)
    const videoRef = useRef(null)
    const [openModal, setOpenModal] = useState(false)


    useEffect(() => {
        if (!openModal) {
            setVideoData(null)
        }
    }, [openModal]);

    function videoStart(item) {
        setVideoData(item)
        setOpenModal(true)
    }

    function onCanPlay() {
        if(videoRef.current){
            console.log('onCanPlay')
            try{
                //@ts-ignore
                videoRef.current.play();
            }catch (e){

            }
        }

    }

    function closeModal() {
        setOpenModal(false)
    }

    return <div className={'HomepageAbout'}>
        <div className={'HomepageAboutContent'}>
            <div className="FeaturesWrapper">
                <h2 className={'features-title'}>{about.title || '7 лет на рынке недвижимости'}</h2>
                <div className={'features-text'}
                     dangerouslySetInnerHTML={{__html: about.subDescription}}/>
                <LinkBtn link={'/about'} staticTexts={staticTexts}/>
            </div>
            <div className={'About-img-wrapper'} onClick={() => {
                videoStart(settings?.aboutVideo)
            }}>
                <div className={'video_block'}>
                    <div  className={'video_play'}>
                        <PlayBtnIcon/>
                    </div>
                    <img src={generateFileMediaUrl(settings?.aboutCover?.path)} alt=""/>
                </div>
            </div>
        </div>
        <div className={'About-bottom-block'}>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className={`counts_item_count `}>
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.credit_count)}
                                         duration={1} delay={4} easing="linear"/>+
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.credit_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.credit_description}
                </div>
            </div>
            <span className={'line'}/>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className="counts_item_count">
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.family_count)}
                                         duration={1} delay={4} easing="linear"/>+
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.family_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.family_description}
                </div>
            </div>
            <span className={'line'}/>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className="counts_item_count">
                                {/*{staticTexts?.square_count}*/}
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.square_count)}
                                         duration={1} delay={4} easing="linear"/>+
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.square_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.square_description}
                </div>
            </div>
            <span className={'line'}/>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className="counts_item_count">
                               <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.annual_count)}
                                         duration={1} delay={4} easing="linear"/>+
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.annual_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.annual_description}
                </div>
            </div>
        </div>
        {openModal && <VideoModal   visible={openModal}
                                    videoData={videoData}
                                    onCanPlay={onCanPlay}
                                    closeModal={closeModal}/>}
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'aboutSlider',
    'about',
    'settings'
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(About);
